/**
 * A helper to determine if a value is a JavaScript primitive.
 *
 * @param obj
 * @returns
 */
export default function isPrimitive(obj) {
  return obj !== Object(obj);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/utils/dist/esm/isPrimitive.js
// module id = 1249
// module chunks = 11